export enum KeyType {
  ADMIN,
  KYC,
  FREEZE,
  WIPE,
  SUPPLY,
  FEE,
  PAUSE,
}
